/**
 * Define global constants for the application
 */
export class GlobalConstants {

    //Production Server 
   public static SERVER_URL = "https://nenosystems.in/PNAC";
    public static DOC_API = "https://prod.nenosystems.in/API/DOCS/api/doc/";
    
    //Devlopment Server
  // public static SERVER_URL = "http://localhost:9099/PNAC";
  //   public static DOC_API = "http://localhost:9092/NCSDOCS/api/doc/";

    //Application context path
    public static CONTEXT_PATH: string = "PNAC";

    /**
     * Default organization ID and Role is used to signup a new user in the application 
     */
    public static DEFAULT_ORG_ID = 1608640805201;
    public static DEFAULT_ROLE = "Guest";

    public static getKey(str: string) {
        return GlobalConstants.CONTEXT_PATH + "-" + str;
    }
}